var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2001 1.60001C6.77575 1.60001 6.36878 1.76858 6.06873 2.06864C5.76867 2.36869 5.6001 2.77566 5.6001 3.20001V9.60001C5.6001 10.0244 5.76867 10.4313 6.06873 10.7314C6.36878 11.0314 6.77575 11.2 7.2001 11.2H12.0001C12.4244 11.2 12.8314 11.0314 13.1315 10.7314C13.4315 10.4313 13.6001 10.0244 13.6001 9.60001V5.13121C13.6 4.70689 13.4314 4.29999 13.1313 4.00001L11.2001 2.06881C10.9001 1.76873 10.4932 1.6001 10.0689 1.60001H7.2001Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 6.4C2.3999 5.97566 2.56847 5.56869 2.86853 5.26863C3.16859 4.96857 3.57556 4.8 3.9999 4.8V12.8H10.3999C10.3999 13.2243 10.2313 13.6313 9.93127 13.9314C9.63121 14.2314 9.22425 14.4 8.7999 14.4H3.9999C3.57556 14.4 3.16859 14.2314 2.86853 13.9314C2.56847 13.6313 2.3999 13.2243 2.3999 12.8V6.4Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDuplicate);
export default __webpack_public_path__ + "static/media/DocumentDuplicate.0a45041c3a65c65de10c8641cafbcadd.svg";
export { ForwardRef as ReactComponent };